export const AppointedPos = [
  {
    position: "President",
    info: [
      {
        title: "Beer Bike Coordinators",
        email: "beerbikejones@gmail.com",
        people: ["Lisa Wang", "Shivani Patel", "Iris Rivera", "Leslie Rojas"],
      },
    ],
  },
  {
    position: "Chief Justice",
    info: [
      {
        title: "Associate Justices",
        people: [
          "Rachel Parr (1N)",
          "Sammie Mahung (2N)",
          "Sawyer Rudy (3N)",
          "Alex Watt (4N)",
          "Nina Yu (2S)",
          "Ellis Vance (3S)",
          "Ian Rodriguez (4S)",
        ],
      },
    ],
  },
  {
    position: "IVP",
    info: [
      {
        title: "Arts and Wellness Coordinators",
        email: "jones.cic5@gmail.com",
        people: ["Charlie Wei", "Taryn Dougherty"],
      },
      {
        title: "Cultural Coordinators",
        email: "jonesculturals@gmail.com",
        people: ["Ayushi Rai", "Safa Merani"],
      },
      {
        title: "Jitchen Coordinators",
        email: "joneskitchencommittee@gmail.com",
        people: ["Lisa Wang", "Isabella Chorley", "Ryan Jafri"],
      },
      {
        title: "EcoReps",
        email: "jones.ecoreps@gmail.com",
        people: ["Dyllan Lozano-Lomelli", "Lily Hestjean"],
      },
      {
        title: "Merchandise Coordinators",
        email: "jonesmerchcoordinators@gmail.com",
        people: ["Charlie Wei", "Lisa Wang", "Emma Qian", "Mia Ridzinski"],
      },
      {
        title: "Theater Coordinators",
        email: "",
        people: ["Josh Carmona"],
      },
    ],
  },
  {
    position: "EVP",
    info: [
      {
        title: "Sports Coordinators",
        email: "jonessportscoords@gmail.com",
        people: ["Alison Turcke", "Craig Pentland"],
      },
      {
        title: "JIBoArd Representative",
        email: "",
        people: ["Caroline Nguyen", "Iris Rivera", "Banesa Valencia"],
      },
      {
        title: "Jones Goes Coordinators",
        email: "",
        people: ["Colin Brennan", "Leslie Rojo Flores", "Zach Rubio"],
      },
    ],
  },
  {
    position: "Secretaries",
    info: [
      {
        title: "Webmagisters",
        email: "jibawebmaster@gmail.com",
        people: ["Anjali Mathew"],
      },
      {
        title: "Historians",
        email: "thejoneshistorian@gmail.com",
        people: ["Mika Chang", "Brian Zhang", "Isabella Chorley"],
      },
      {
        title: "Social Media Directors",
        email: "jonesprdirector@gmail.com",
        people: ["CJ Friend", "Alison Turcke"],
      },
    ],
  },
];
